/**
 * =============================================================================
 * @encoding UTF-8
 * @author [Zerohold](//zerohold.sd1.su)
 * @project [SD1](//sd1.su)
 * @summary Обработчик глобальных ошибок (500 и прочие)
 * @created 2026-06
 * @modified 2026-06
 *
 * @file D:/node/sd1.su/sd1.su/src/app/error.tsx
 * @link https://sd1.su/
 *
 * @remarks
 * - Скрывает глобальные элементы (header, aside) через CSS.
 * =============================================================================
 */

'use client';

// Хук побочных эффектов React и тип элемента
import React, {useEffect, type ReactElement} from 'react';

// Компонент навигации Next.js
import Link from 'next/link';

/**
 * @summary Страница ошибки
 * @param {Object} _props - Свойства компонента
 * @param {Error & { digest?: string }} _props.error - Объект ошибки
 * @param {() => void} _props.reset - Функция для попытки восстановления
 * @return {ReactElement}
 */
export default function ErrorPage({
                                    error,
                                    reset,
                                  }: {
  error: Error & { digest?: string };
  reset: () => void;
}): ReactElement
{
  useEffect(() =>
  {
    // Логирование ошибки (можно отправлять в Sentry и т.д.)
    console.error('Global error caught:', error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 text-center">
      {/* Скрываем глобальные элементы интерфейса только для страницы с ошибкой */}
      <style dangerouslySetInnerHTML={{
        __html: `
        .header, .aside, .breadcrumb { display: none !important; }
      `
      }}/>

      <h1 className="text-6xl font-bold text-zinc-900 mb-4">
        Ошибка
      </h1>
      <h2 className="text-2xl font-semibold text-zinc-700 mb-6">
        Что-то пошло не так
      </h2>
      <p className="text-zinc-500 mb-8 max-w-md">
        Произошла непредвиденная системная ошибка. Мы уже работаем над ее устранением.
      </p>

      <div className="flex gap-4">
        <button
          onClick={() => reset()}
          className="btn btn-secondary btn-sm"
        >
          Попробовать снова
        </button>
        <Link
          href="/"
          className="btn btn-primary btn-sm"
        > На главную </Link>
      </div>
    </div>
  );
}